import React from "react";
import Nav from "../../Nav/Nav";
import "./HomeCarousel.css";

export default function HomeCarousel() {
  return (
    <>
      <div
        id="carouselExampleCaptions"
        className="carousel slide homecarousel"
        data-bs-ride="false"
        style={{ position: "relative" }}
      >
        <Nav />
        <div className="mask_overlay"></div>
        <div
          style={{ zIndex: "50", visibility: "hidden" }}
          className="carousel-indicators"
        >
          <button
            type="button"
            data-bs-target="#carouselExampleCaptions"
            data-bs-slide-to="0"
            className="active"
            aria-current="true"
            aria-label="Slide 1"
          ></button>
          <button
            type="button"
            data-bs-target="#carouselExampleCaptions"
            data-bs-slide-to="1"
            aria-label="Slide 2"
          ></button>
          <button
            type="button"
            data-bs-target="#carouselExampleCaptions"
            data-bs-slide-to="2"
            aria-label="Slide 3"
          ></button>
        </div>
        <div className="carousel-inner">
          {/* First Carousel start */}

          <div className="carousel-item active">
            <img
              src="/Images/babloo.jpg"
              className="d-block w-100 car_img"
              alt="CodeStack Labs"
            />
            <div
              style={{
                zIndex: "50",
                position: "absolute",
                top: "40vh",
              }}
              className="carousel-caption align-items-center"
            >
              <h1 className="mb-5 car_head">
                <span
                  className="d-none d-md-inline"
                  style={{
                    fontSize: "25px",
                    opacity: "0.8",
                    position: "relative",
                    top: "-40px",
                  }}
                >
                  {"<h1>"}
                </span>
                Hello World
                <span
                  className="d-none d-md-inline"
                  style={{
                    fontSize: "25px",
                    opacity: "0.8",
                    position: "relative",
                    bottom: "-20px",
                  }}
                >
                  {"</h1>"}
                </span>
              </h1>
              <p className="caro_para">
                <span
                  className="d-none d-md-inline"
                  style={{
                    fontSize: "25px",
                    opacity: "0.8",
                    position: "relative",
                    top: "-40px",
                  }}
                >
                  {"<p>"}
                </span>
                My name is Bobby kumar am a Computer Science student & Computer
                enthusiast, 18 yrs old.
                <span
                  className="d-none d-md-inline"
                  style={{
                    fontSize: "25px",
                    opacity: "0.8",
                    position: "relative",
                    bottom: "-10px",
                  }}
                >
                  {"<p>"}
                </span>
              </p>
              <button className="caro_Btn mt-2">About Us</button>
            </div>
          </div>

          {/* Second Carousel Start */}
          <div className="carousel-item">
            <img
              src="/Images/nitesh.jpg"
              className="d-block w-100 car_img"
              alt="Code Stack Labs"
            />
            <div
              style={{ zIndex: "50", position: "absolute", top: "39vh" }}
              className="carousel-caption"
            >
              <h1 className="mb-5 car_head">
                <span
                  className="d-none d-md-inline"
                  style={{
                    fontSize: "25px",
                    opacity: "0.8",
                    position: "relative",
                    top: "-40px",
                  }}
                >
                  {"<h1>"}
                </span>
                Education's
                <span
                  className="d-none  d-md-inline"
                  style={{
                    fontSize: "25px",
                    opacity: "0.8",
                    position: "relative",
                    bottom: "-20px",
                  }}
                >
                  {"</h1>"}
                </span>
              </h1>
              <p className="caro_para">
                <span
                  className="d-none d-md-inline"
                  style={{
                    fontSize: "25px",
                    opacity: "0.8",
                    position: "relative",
                    top: "-40px",
                  }}
                >
                  {"<p>"}
                </span>
                Student at AIMIT Patna . It is affiliated to Maulana Mazharul
                Haque Arabic and Persian University is a State University in
                Patna, Bihar, India.
                <span
                  className="d-none d-md-inline"
                  style={{
                    fontSize: "25px",
                    opacity: "0.8",
                    position: "relative",
                    bottom: "-20px",
                  }}
                >
                  {"<p>"}
                </span>
              </p>
              <a href="#ourTools">
                <button className="caro_Btn mt-5">Education</button>
              </a>
            </div>
          </div>

          {/* Third Carousel start */}
          <div className="carousel-item">
            <img
              src="/Images/pc1.jpeg"
              className="d-block w-100 car_img"
              alt="Codestack labs"
            />
            <div
              style={{ zIndex: "50", position: "absolute", top: "35vh" }}
              className="carousel-caption"
            >
              <h1 className="mb-5 car_head">
                <span
                  className="d-none d-md-inline"
                  style={{
                    fontSize: "25px",
                    opacity: "0.8",
                    position: "relative",
                    top: "-40px",
                  }}
                >
                  {"<h1>"}
                </span>
                Hobbie's
                <span
                  className="d-none d-md-inline"
                  style={{
                    fontSize: "25px",
                    opacity: "0.8",
                    position: "relative",
                    bottom: "-20px",
                  }}
                >
                  {"</h1>"}
                </span>
              </h1>
              <p className="caro_para">
                <span
                  className="d-none d-md-inline"
                  style={{
                    fontSize: "25px",
                    opacity: "0.8",
                    position: "relative",
                    top: "-40px",
                  }}
                >
                  {"<p>"}
                </span>
                My hobbie's as like as Work for Projects, Play online game
                Watching movie espcially Comedy Movie, and web-show.
                <span
                  className="d-none d-md-inline"
                  style={{
                    fontSize: "25px",
                    opacity: "0.8",
                    position: "relative",
                    bottom: "-20px",
                  }}
                >
                  {"<p>"}
                </span>
              </p>
              <button className="caro_Btn mt-5">Hobbie</button>
            </div>
          </div>
        </div>
        <button
          style={{ zIndex: "50" }}
          className="carousel-control-prev"
          type="button"
          data-bs-target="#carouselExampleCaptions"
          data-bs-slide="prev"
        >
          <span
            className="carousel-control-prev-icon"
            aria-hidden="true"
          ></span>
          <span className="visually-hidden">Previous</span>
        </button>
        <button
          style={{ zIndex: "50" }}
          className="carousel-control-next"
          type="button"
          data-bs-target="#carouselExampleCaptions"
          data-bs-slide="next"
        >
          <span
            className="carousel-control-next-icon"
            aria-hidden="true"
          ></span>
          <span className="visually-hidden">Next</span>
        </button>
      </div>
    </>
  );
}
